import React from "react";
import UserCommissionValue from "./UserCommissionValue";
import { AgreementLevelName } from "../../../util";

const LeadershipCommissionList = ({ leaderships = [], emptyLabel = "N/A" }) => {
  const leadershipsWithoutCCO = leaderships.filter(({ levelName }) => levelName !== AgreementLevelName.CCO);

  if (!leadershipsWithoutCCO.length) {
    return emptyLabel;
  }

  return (
    <>
      {leadershipsWithoutCCO.map(({ userId, leadershipOneTimeCommission }, index) => (
        <UserCommissionValue
          key={userId}
          userId={userId}
          amount={leadershipOneTimeCommission}
          divider={index < leadershipsWithoutCCO.length - 1}
        />
      ))}
    </>
  );
};

export default React.memo(LeadershipCommissionList);
